const filterList = document.querySelector(".faq-filters");
const filterButtons = filterList.querySelectorAll(".faq-filter__btn");
const faqFilterContent = document.querySelectorAll(".faq-filter-content");
const accordionItems = document.querySelectorAll(".accordion-item");

function filterFAQ(filter) {
    let anyVisible = false;

    accordionItems.forEach((item) => {
        const contentBlocks = item.querySelectorAll(".faq-filter-content");
        let hasMatchingCategory = false;

        contentBlocks.forEach((contentBlock) => {
            let contentCategory = contentBlock.getAttribute("data-category");

            if (filter === "all" || filter === contentCategory) {
                contentBlock.removeAttribute("hidden");
                hasMatchingCategory = true;
            } else {
                contentBlock.setAttribute("hidden", "");
            }
        });

        if (hasMatchingCategory) {
            item.style.display = "block";
            anyVisible = true;
        } else {
            item.style.display = "none";
        }
    });

    if (!anyVisible) {
        document.querySelector(".accordion").style.display = "none";
    } else {
        document.querySelector(".accordion").style.display = "block";
    }
}

function checkFilterButtons() {
    filterButtons.forEach((button) => {
        let filterCategory = button.value;
        let label = button.closest('label');
        let hasMatchingContent = Array.from(faqFilterContent).some(
            (contentBlock) => contentBlock.getAttribute("data-category") === filterCategory
        );


        if (filterCategory === "all" || hasMatchingContent) {

            label.style.display = "inline-block";
        } else {
            label.style.display = "none";
        }
    });
}

filterButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
        let filterCategory = e.currentTarget.value;
        filterFAQ(filterCategory);
    });
});

checkFilterButtons();